export default "__VITE_ASSET__8$_m_7JG__"